"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var ResourceAccessModal_module_css_1 = __importDefault(require("../common/ResourceAccessModal.module.css"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var AutocompleteUserSelection_1 = __importDefault(require("../common/AutocompleteUserSelection"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var Checkbox_1 = __importDefault(require("../common/Checkbox"));
var Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
var FolderAccessModal = function (props) {
    var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var _a = (0, react_1.useState)([]), allQteams = _a[0], setAllQteams = _a[1];
    var _b = (0, react_1.useState)([]), qteams = _b[0], setQteams = _b[1];
    var _c = (0, react_1.useState)({}), initialRoles = _c[0], setInitialRoles = _c[1];
    var _d = (0, react_1.useState)([]), newTeamRows = _d[0], setNewTeamRows = _d[1];
    var _e = (0, react_1.useState)([]), assignableRoles = _e[0], setAssignableRoles = _e[1];
    var _f = (0, react_1.useState)([]), inheritedPermissions = _f[0], setInheritedPermissions = _f[1];
    var _g = (0, react_1.useState)([]), globalPermissions = _g[0], setGlobalPermissions = _g[1];
    var updateRoles = function (qteamId, accessRole, value) {
        setQteams(function (qteams) { return qteams.map(function (qteam) {
            if (qteam.id === qteamId) {
                var currentRoles = qteam.accessRoles || { read: false, write: false, manager: false };
                var newRoles = __assign({}, currentRoles);
                if (accessRole === "write" && value) {
                    newRoles.read = true;
                }
                if (accessRole === "manager" && value) {
                    newRoles.read = true;
                    newRoles.write = true;
                }
                if (accessRole === "write" && !value) {
                    newRoles.manager = false;
                }
                if (accessRole === "read" && !value) {
                    newRoles.write = false;
                    newRoles.manager = false;
                }
                newRoles[accessRole] = value;
                return __assign(__assign({}, qteam), { accessRoles: newRoles });
            }
            return qteam;
        }); });
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var rolesMapping, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rolesMapping = {};
                    qteams.forEach(function (team) {
                        var initial = initialRoles[team.id] || {};
                        var current = team.accessRoles;
                        if (JSON.stringify(initial) !== JSON.stringify(current)) {
                            var roles = [];
                            roles = assignableRoles.filter(function (role) { return role.group === 3; });
                            if (current.manager) {
                                rolesMapping[team.id] = roles.filter(function (role) { return role.order === 2; })[0].name;
                            }
                            else if (current.write) {
                                rolesMapping[team.id] = roles.filter(function (role) { return role.order === 1; })[0].name;
                            }
                            else if (current.read) {
                                rolesMapping[team.id] = roles.filter(function (role) { return role.order === 0; })[0].name;
                            }
                            else {
                                rolesMapping[team.id] = null;
                            }
                        }
                    });
                    Object.keys(initialRoles).forEach(function (teamId) {
                        if (!qteams.some(function (team) { return team.id.toString() === teamId; })) {
                            rolesMapping[teamId] = null;
                        }
                    });
                    if (!(Object.keys(rolesMapping).length > 0)) return [3 /*break*/, 6];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    if (!props.resourceId) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateResourceRoles(props.resourceId, rolesMapping)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    logger.error("Failed to save roles", error_1);
                    return [3 /*break*/, 6];
                case 5:
                    props.onClose();
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var updateResourceRoles = function (resourceId, rolesMapping) { return __awaiter(void 0, void 0, void 0, function () {
        var updates, _i, updates_1, _a, qteamId, role, onlineResource;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    updates = Object.entries(rolesMapping).map(function (_a) {
                        var qteamId = _a[0], role = _a[1];
                        return ({
                            qteamId: parseInt(qteamId),
                            role: role,
                        });
                    });
                    _i = 0, updates_1 = updates;
                    _b.label = 1;
                case 1:
                    if (!(_i < updates_1.length)) return [3 /*break*/, 4];
                    _a = updates_1[_i], qteamId = _a.qteamId, role = _a.role;
                    if (!!isNaN(qteamId)) return [3 /*break*/, 3];
                    onlineResource = onlineResourceManager.makeJSONRequest("/api/media-library/folder/".concat(resourceId, "/qteam/").concat(qteamId, "/access"), "PATCH", JSON.stringify({
                        role: role
                    }));
                    return [4 /*yield*/, onlineResource.getDataAsJSON()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getAccessRoles = function (permission) {
        var accessRoles = {
            read: false,
            write: false,
            manager: false,
        };
        if (permission === "Manager") {
            accessRoles = {
                read: true,
                write: true,
                manager: true,
            };
        }
        else if (permission === "Write") {
            accessRoles = {
                read: true,
                write: true,
                manager: false,
            };
        }
        else if (permission === "Read") {
            accessRoles = {
                read: true,
                write: false,
                manager: false,
            };
        }
        return accessRoles;
    };
    var getPermissionLevel = function (permissionNames) {
        var permissions = permissionNames.split(",");
        if (permissions.some(function (permission) { return permission.includes("manager"); })) {
            return "Manager";
        }
        else if (permissions.some(function (permission) { return permission.includes("write"); })) {
            return "Write";
        }
        else if (permissions.some(function (permission) { return permission.includes("read"); })) {
            return "Read";
        }
    };
    var fetchTeamsAndRoles = function () { return __awaiter(void 0, void 0, void 0, function () {
        var teamsResponse, getAccess, teamsAccess, directAccess, globalAccess, inheritedAccess, directPermissions, globalPermissions_1, inheritedPermissions_1, rolesMap, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.isShown || !props.resourceId)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, ApiManager_1.default.getQteams()];
                case 2:
                    teamsResponse = _a.sent();
                    setAllQteams(teamsResponse);
                    getAccess = onlineResourceManager.makeJSONRequest("/api/media-library/folders/".concat(props.resourceId, "/qteam/access"));
                    return [4 /*yield*/, getAccess.getDataAsJSON()];
                case 3:
                    teamsAccess = _a.sent();
                    directAccess = teamsAccess.direct;
                    globalAccess = teamsAccess.global;
                    inheritedAccess = teamsAccess.inherited;
                    directPermissions = directAccess.map(function (team) { return ({
                        id: team.id,
                        name: team.name,
                        accessRoles: getAccessRoles(getPermissionLevel(team.permission_names))
                    }); }).filter(function (directPermission) { return directPermission.accessRoles; });
                    globalPermissions_1 = globalAccess.map(function (team) { return ({
                        teamId: team.id,
                        teamName: team.name,
                        permission: getPermissionLevel(team.permission_names)
                    }); }).filter(function (globalpermission) { return globalpermission.permission; });
                    inheritedPermissions_1 = inheritedAccess.map(function (team) { return ({
                        teamId: team.id,
                        teamName: team.name,
                        permission: getPermissionLevel(team.permission_names)
                    }); }).filter(function (inheritedPermission) { return inheritedPermission.permission; });
                    rolesMap = directPermissions.reduce(function (accumulated, current) {
                        accumulated[current.teamId] = current.accessRoles;
                        return accumulated;
                    }, {});
                    setQteams(directPermissions);
                    setInitialRoles(rolesMap);
                    setGlobalPermissions(globalPermissions_1);
                    setInheritedPermissions(inheritedPermissions_1);
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    logger.error("Error fetching teams or roles:", error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleNewTeamSelectionChange = function (index, newTeamId) {
        var selectedTeam = allQteams.find(function (team) { return team.id === newTeamId; });
        if (!selectedTeam) {
            logger.error("Selected team not found in allQteams", newTeamId);
            return;
        }
        setQteams(function (prev) { return __spreadArray(__spreadArray([], prev, true), [__assign(__assign({}, selectedTeam), { accessRoles: { read: false, write: false, manager: false } })], false); });
        var updatedNewTeamRows = __spreadArray([], newTeamRows, true);
        updatedNewTeamRows.splice(index, 1);
        setNewTeamRows(updatedNewTeamRows);
    };
    var addNewTeamRow = function () {
        setNewTeamRows(__spreadArray(__spreadArray([], newTeamRows, true), [{ id: Date.now() }], false));
    };
    var removeTeamRow = function (index, isNew) {
        if (isNew === void 0) { isNew = false; }
        if (isNew) {
            var updatedNewTeamRows = __spreadArray([], newTeamRows, true);
            updatedNewTeamRows.splice(index, 1);
            setNewTeamRows(updatedNewTeamRows);
        }
        else {
            var updatedQteams = __spreadArray([], qteams, true);
            var removedTeam = updatedQteams.splice(index, 1)[0];
            setQteams(updatedQteams);
            if (removedTeam) {
                var updatedRolesMapping = __assign({}, initialRoles);
                updatedRolesMapping[removedTeam.id] = null;
                setInitialRoles(updatedRolesMapping);
            }
        }
    };
    (0, react_1.useEffect)(function () {
        fetchTeamsAndRoles();
    }, [props.isShown, props.resourceId]);
    (0, react_1.useEffect)(function () {
        if (!props.isShown) {
            setNewTeamRows([]);
        }
    }, [props.isShown]);
    (0, react_1.useEffect)(function () {
        ApiManager_1.default.getResourceRoles().then(function (roles) {
            setAssignableRoles(roles);
        });
    }, []);
    var body = (react_1.default.createElement("div", { style: { color: "var(--info-color)" }, className: ResourceAccessModal_module_css_1.default.body },
        react_1.default.createElement("div", { className: "".concat(ResourceAccessModal_module_css_1.default.heading_container, " ns-font-family-bold") },
            react_1.default.createElement("div", { style: { flex: "0 0 55%" } }, t("Teams")),
            react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.roles_heading_text },
                react_1.default.createElement("div", null, t("Read")),
                react_1.default.createElement("div", null, t("Write")),
                react_1.default.createElement("div", null, t("Manager")))),
        react_1.default.createElement("div", null,
            qteams.length === 0 && (react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.teams_list },
                react_1.default.createElement("div", { style: { flex: "1 1 35%" } },
                    react_1.default.createElement(AutocompleteUserSelection_1.default, { users: allQteams.filter(function (qteam) { return !qteams.some(function (existingTeam) { return existingTeam.id === qteam.id; }); }), handleMemberSelectionChange: handleNewTeamSelectionChange, member: null, label: t("Select a team") })))),
            qteams.map(function (qteam, index) {
                var _a, _b, _c;
                return (react_1.default.createElement("div", { key: qteam.id, className: ResourceAccessModal_module_css_1.default.teams_list },
                    react_1.default.createElement("div", { style: { flex: "1 1 35%", padding: "10px" } }, qteam.name),
                    react_1.default.createElement("div", { style: { display: "flex", flexGrow: 1, justifyContent: "space-around" } },
                        react_1.default.createElement(Checkbox_1.default, { checked: ((_a = qteam.accessRoles) === null || _a === void 0 ? void 0 : _a.read) || false, onChange: function () { var _a; return updateRoles(qteam.id, "read", !((_a = qteam.accessRoles) === null || _a === void 0 ? void 0 : _a.read)); } }),
                        react_1.default.createElement(Checkbox_1.default, { checked: ((_b = qteam.accessRoles) === null || _b === void 0 ? void 0 : _b.write) || false, onChange: function () { var _a; return updateRoles(qteam.id, "write", !((_a = qteam.accessRoles) === null || _a === void 0 ? void 0 : _a.write)); } }),
                        react_1.default.createElement(Checkbox_1.default, { checked: ((_c = qteam.accessRoles) === null || _c === void 0 ? void 0 : _c.manager) || false, onChange: function () { var _a; return updateRoles(qteam.id, "manager", !((_a = qteam.accessRoles) === null || _a === void 0 ? void 0 : _a.manager)); } })),
                    react_1.default.createElement(q_play_components_1.Button, { text: "-", onClick: function () { return removeTeamRow(index); }, style: {
                            marginLeft: "auto",
                            padding: "0 5px",
                            borderRadius: "5px",
                            backgroundColor: "var(--secondary-color)",
                            color: "var(--info-color)",
                            maxWidth: "18px",
                            minWidth: "18px"
                        } })));
            }),
            newTeamRows.map(function (row, index) { return (react_1.default.createElement("div", { key: "newTeam-".concat(index), className: ResourceAccessModal_module_css_1.default.teams_list },
                react_1.default.createElement("div", { style: { flex: "1 1 35%" } }, (!qteams.length || newTeamRows.length > 0 || qteams.every(function (qteam) { return !qteam.accessRoles.read && !qteam.accessRoles.write && !qteam.accessRoles.manager; })) && (react_1.default.createElement(AutocompleteUserSelection_1.default, { users: allQteams.filter(function (qteam) { return !qteams.concat(newTeamRows).some(function (existingTeam) { return existingTeam.id === qteam.id; }); }), handleMemberSelectionChange: handleNewTeamSelectionChange, member: null, label: t("Select a team") }))),
                react_1.default.createElement(q_play_components_1.Button, { text: "-", onClick: function () { return removeTeamRow(index, true); }, style: {
                        marginLeft: "auto",
                        padding: "0 5px",
                        borderRadius: "5px",
                        backgroundColor: "var(--secondary-color)",
                        color: "var(--info-color)",
                        maxWidth: "18px",
                        minWidth: "18px"
                    }, dataCy: "removeTeamMember" }))); })),
        react_1.default.createElement(q_play_components_1.Button, { onClick: addNewTeamRow, className: ResourceAccessModal_module_css_1.default.add_team_button, text: "+", style: { width: "100%" } }),
        react_1.default.createElement("div", { className: "".concat(ResourceAccessModal_module_css_1.default.inherited_heading_text, " ns-font-family-bold"), style: { marginTop: "40px" } },
            react_1.default.createElement("h1", { style: { fontSize: "17px" } }, t("Inherited access"))),
        react_1.default.createElement("div", { className: "".concat(ResourceAccessModal_module_css_1.default.inherited_heading_text, " ns-font-family-bold") },
            react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.inherited_list_wrapper },
                react_1.default.createElement("div", { style: { flexBasis: "23.5%", fontSize: "15px" } }, t("Team")),
                react_1.default.createElement("div", { style: { flexBasis: "24%", marginRight: "-15px", fontSize: "15px" } }, t("Access")))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null, globalPermissions.map(function (globalpermission) { return globalpermission.permission && (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement("pre", { className: ResourceAccessModal_module_css_1.default.tooltip_styling }, t("Global folder access is managed on the teams.")), placement: "right-end", arrow: true, key: globalpermission.teamId, PopperProps: {
                    sx: {
                        ".MuiTooltip-arrow": {
                            color: "var(--secondary-color)",
                        },
                        ".MuiTooltip-tooltip": {
                            backgroundColor: "var(--secondary-color)",
                            color: "var(--info-color)",
                            borderRadius: "7px",
                            padding: "12px"
                        },
                    },
                } },
                react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.inherited_teams_list },
                    react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.inherited_list_wrapper },
                        react_1.default.createElement("span", { className: ResourceAccessModal_module_css_1.default.team_name }, globalpermission.teamName),
                        react_1.default.createElement("span", { className: ResourceAccessModal_module_css_1.default.permission_name }, t(globalpermission.permission)))))); })),
            react_1.default.createElement("div", null, inheritedPermissions.map(function (permission, index) { return (react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement("pre", { className: ResourceAccessModal_module_css_1.default.tooltip_styling }, t("Inherited folder access is managed on the parent folders.")), placement: "right-end", arrow: true, key: index, PopperProps: {
                    sx: {
                        ".MuiTooltip-arrow": {
                            color: "var(--secondary-color)",
                        },
                        ".MuiTooltip-tooltip": {
                            backgroundColor: "var(--secondary-color)",
                            color: "var(--info-color)",
                            borderRadius: "7px",
                            padding: "12px"
                        },
                    },
                } },
                react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.inherited_teams_list },
                    react_1.default.createElement("div", { className: ResourceAccessModal_module_css_1.default.inherited_list_wrapper },
                        react_1.default.createElement("span", { className: ResourceAccessModal_module_css_1.default.team_name }, permission.teamName),
                        react_1.default.createElement("span", { className: ResourceAccessModal_module_css_1.default.permission_name }, permission.permission))))); })))));
    var footer = (react_1.default.createElement("div", null,
        react_1.default.createElement(q_play_components_1.Button, { onClick: handleSave, text: t("Save") })));
    var CustomHeader = (react_1.default.createElement("div", { className: "ns-font-family-bold", style: { fontSize: "25px" } },
        react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, t("Manage team access")),
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { style: { color: "var(--primary-color)" } },
                " ",
                props.resourceName))));
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: props.onClose, centered: true, header: CustomHeader, body: body, footer: footer, dialogClassName: ResourceAccessModal_module_css_1.default.resource_access_modal }));
};
exports.default = FolderAccessModal;
